<global-loader></global-loader>
<router-outlet></router-outlet>
